import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { L, imgOf, useFetch, useTitle } from "../lib";
import { SampleTag, Lightbox, ArtImage } from "../ui";

const Row = ({ k, v, testid }) => v ? <div className="py-3 border-b border-lou-line grid grid-cols-3 gap-4 text-sm" data-testid={testid}><dt className="text-lou-soft">{k}</dt><dd className="col-span-2">{v}</dd></div> : null;

export default function PhotoDetail() {
  const { id } = useParams();
  const { data: p, error } = useFetch(`/photos/${id}`, [id]);
  const [lb, setLb] = useState(null);
  useTitle("Photograph");
  if (error) return <p className="max-w-6xl mx-auto px-6 py-24" data-testid="photo-not-found">This photograph could not be found.</p>;
  if (!p) return <div className="h-[70vh]" />;
  return (
    <article className="max-w-7xl mx-auto px-6 lg:px-10 pt-10 sm:pt-16 grid lg:grid-cols-12 gap-12" data-testid="photo-detail">
      <div className="lg:col-span-7">
        <Link to={L(p.album_id ? `/photographs/album/${p.album_id}` : "/photographs")} className="text-sm text-lou-soft hover:text-lou-clay">← Photographs</Link>
        <button className="block w-full mt-6 relative" onClick={() => setLb(0)} aria-label="View full screen" data-testid="photo-detail-open">
          <ArtImage src={imgOf(p)} alt={p.caption || "Photograph"} />
          <SampleTag show={p.is_sample} className="absolute top-3 left-3" />
        </button>
      </div>
      <div className="lg:col-span-5 lg:pt-14">
        <h1 className="font-lou text-3xl sm:text-4xl font-light" data-testid="photo-caption">{p.caption || "Untitled photograph"}</h1>
        <dl className="mt-6 border-t border-lou-line">
          <Row k="When" v={p.date_text} /><Row k="Where" v={p.location} /><Row k="Pictured" v={p.people} />
          <Row k="Photograph by" v={p.photographer_credit} testid="photo-photographer" />
          <Row k="Shared by" v={p.uploader_name} testid="photo-uploader" />
        </dl>
        {p.story && <p className="mt-6 text-lou-soft leading-relaxed whitespace-pre-line">{p.story}</p>}
      </div>
      <Lightbox items={[{ src: imgOf(p), title: p.caption }]} index={lb} onClose={() => setLb(null)} onIndex={setLb} />
    </article>
  );
}
